import axios from 'axios';

const HELPERS = {
  // Email validation - RFC 5322 compliant
  validateEmail: (email) => {
    if (!email || typeof email !== 'string') return false;
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase().trim());
  },

  // Phone number validation - 10 digits
  validatePhone: (phone) => {
    if (!phone || typeof phone !== 'string') return false;
    const cleanPhone = phone.replace(/\D/g, '');
    return /^[0-9]{10}$/.test(cleanPhone);
  },

  // Input sanitization - Remove HTML tags and dangerous characters
  sanitizeInput: (input) => {
    if (!input || typeof input !== 'string') return '';
    return input
      .trim()
      .replace(/[<>]/g, '') // Remove < and > to prevent HTML injection
      .replace(/javascript:/gi, '') // Remove javascript: protocol
      .replace(/on\w+\s*=/gi, '') // Remove inline event handlers
      .substring(0, 1000); // Limit length
  },

  // Name validation
  validateName: (name) => {
    if (!name || typeof name !== 'string') return false;
    const sanitized = HELPERS.sanitizeInput(name);
    return sanitized.length >= 2 && sanitized.length <= 100;
  },

  // API call helper with timeout and error handling
  ApiCall: async (url, data, method = 'GET', apiType = 'proctur', headers = {}) => {
    try {
      // Validate URL
      if (!url || typeof url !== 'string') {
        throw new Error('Invalid API URL');
      }

      // Ensure URL is HTTPS in production
      if (process.env.NODE_ENV === 'production' && !url.startsWith('https://')) {
        throw new Error('API calls must use HTTPS in production');
      }

      const config = {
        method: method,
        url: url,
        timeout: 30000, // 30 second timeout
        ...headers
      };

      if (method === 'POST' || method === 'PUT') {
        // Sanitize data before sending
        if (data && typeof data === 'object') {
          const sanitizedData = {};
          Object.keys(data).forEach(key => {
            if (typeof data[key] === 'string') {
              sanitizedData[key] = HELPERS.sanitizeInput(data[key]);
            } else {
              sanitizedData[key] = data[key];
            }
          });
          config.data = sanitizedData;
        } else {
          config.data = data;
        }
      }

      const response = await axios(config);
      return response;
    } catch (error) {
      // Log error for debugging (in production, send to monitoring service)
      console.error('API Call Error:', {
        url: url,
        method: method,
        error: error.message
      });
      throw error;
    }
  },

  // Rate limiting check (basic client-side)
  checkRateLimit: (key, maxAttempts = 5, timeWindow = 60000) => {
    const storageKey = `rateLimit_${key}`;
    const now = Date.now();

    try {
      const attempts = JSON.parse(localStorage.getItem(storageKey) || '[]');
      const recentAttempts = attempts.filter(time => now - time < timeWindow);

      if (recentAttempts.length >= maxAttempts) {
        return false; // Rate limit exceeded
      }

      recentAttempts.push(now);
      localStorage.setItem(storageKey, JSON.stringify(recentAttempts));
      return true;
    } catch (error) {
      // If localStorage fails, allow the request
      return true;
    }
  }
};

export default HELPERS;
